import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class AttendanceUpdateRequest {

    @ApiProperty()
    employeeCode: string;
    @ApiProperty()
    employeeName?: string;
    @ApiProperty()
    date?: string;
    @ApiProperty()
    inTime?: string;
    @ApiProperty()
    outTime?: string;
    @ApiProperty()
    presentStatus?: string;
    @ApiProperty()
    status?: LeaveApprovalStatusEnum;
    @ApiProperty()
    reason?: string
    @ApiProperty()
    user: string;

    /**
     * 
     * @param employeeCode 
     * @param employeeName 
     * @param date 
     * @param inTime 
     * @param outTime 
     * @param presentStatus 
     * @param status 
     * @param reason 
     */
    constructor(employeeCode: string, employeeName?: string, date?: string, inTime?: string, outTime?: string, presentStatus?: string, status?: LeaveApprovalStatusEnum, reason?: string, user?: string) {

        this.employeeCode = employeeCode;
        this.employeeName = employeeName
        this.date = date;
        this.inTime = inTime;
        this.outTime = outTime;
        this.presentStatus = presentStatus;
        this.status = status
        this.reason = reason;
        this.user = user;
    }
}